<template lang='pug'>
div.internal-link-input-wrapper(v-show="optionsLoaded")
  div.input-group
    label(for="internal-link-type") Internal link type:
    select#internal-link-type(v-model="internalLinkType")
      option(:value="null") Select an internal link type
      option(
        v-for="item in coachingMessageInternalLinkOptions"
        :value="item")
        | {{ item.name }}
  template(v-if="internalLinkType && internalLinkType.suffix && internalLinkType.suffix.length > 0")
    div.input-group.suffix-wrapper(v-for="(suffix, index) in internalLinkType.suffix")
      div.label-inline-wrapper
        label.label-inline(:for="`suffix-input-${suffix.name}`") {{ suffix.name | capitalize }}:
        template(v-if="suffix.type === 'text'")
          span.has-tooltip.link-highlight(@click="toggleTextToolTip()")
            | ?
          transition(name="fade")
            .internal-link-tooltip-content.tooltip-content(
              v-if="showTextToolTip"
              @mouseleave="setShowTextToolTip(false)")
              section.tooltip-body(
                v-html="getInternalLinkToolTipContent(internalLinkType.base)")
      template(v-if="suffix.type === 'text'")
        input(:id="`suffix-input-${suffix.name}`" type="text" v-model.trim="suffixContent[index]")
      template(v-if="suffix.type === 'option'")
        select(:id="`suffix-input-${suffix.name}`" v-model="suffixContent[index]")
          option(value="") Select a option
          option(v-for="item in suffix.options" :value="item")
            | {{ item }}
  validation-message(:message="internalLinkValidationMessage")
</template>
<script>
import ValidationMessage from '@/components/coaching/cannedResponses/ValidationMessage.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CoachingMessageInternalLinkInput',
  components: {
    ValidationMessage
  },
  data() {
    return {
      optionsLoaded: false,
      internalLinkType: null,
      attachmentValid: null,
      suffixContent: [],
      internalLinkValidationMessage: '',
      showTextToolTip: false
    };
  },
  computed: {
    ...mapGetters(['coachingMessageInternalLinkOptions'])
  },
  filters: {
    capitalize: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    init() {
      this.optionsLoaded = true;
    },
    validateAttachment() {
      this.attachmentValid = false;

      if (!this.internalLinkType) {
        this.internalLinkValidationMessage =
          'Please select an internal link type';
        return;
      }

      // Validate suffix
      if (this.internalLinkType.suffix) {
        this.validateInternalLinkSuffix();
      } else {
        // internalLinkType without suffix
        this.attachmentValid = true;
      }
    },
    validateInternalLinkSuffix() {
      let validationMessages = [];

      // Validate suffixContent against the set internalLinkType
      const suffixContentValidity = this.internalLinkType.suffix.reduce(
        (acc, item, index) => {
          const suffixContentItem = this.suffixContent[index];
          let isValid = false;

          if (item.type === 'text') {
            isValid = this.internalLinkTypeTextValid(item, suffixContentItem);
          } else if (item.type === 'option') {
            isValid = this.internalLinkTypeOptionValid(item, suffixContentItem);
          }

          // Set validation message(s)
          if (!isValid) {
            const nameHasVowel = this.stringStartsWithVowel(item.name);
            validationMessages.push(
              `set ${nameHasVowel ? 'an' : 'a'} ${item.name}`
            );
          }

          acc.push(isValid);
          return acc;
        },
        []
      );

      if (!suffixContentValidity.includes(false)) {
        this.internalLinkValidationMessage = '';

        // Timeout needed to prevent attachmentValid watch race condition
        setTimeout(() => {
          this.attachmentValid = true;
        }, 100);
      } else {
        // Format validationMessages into readable string
        let newValidationMessage = validationMessages
          .join(' and ')
          .toLowerCase();
        this.internalLinkValidationMessage = `Please ${newValidationMessage}.`;
      }
    },
    internalLinkTypeTextValid(item, suffixContentItem) {
      let isValid = false;
      if (!item.required) {
        isValid = true;
      } else if (suffixContentItem.length > 0) {
        isValid = true;
      }
      return isValid;
    },
    internalLinkTypeOptionValid(item, suffixContentItem) {
      let isValid = false;
      if (!item.required) {
        isValid = true;
      } else if (item.options.includes(suffixContentItem)) {
        isValid = true;
      }
      return isValid;
    },
    getInternalMessageString() {
      if (
        !this.internalLinkType.suffix ||
        this.internalLinkType.suffix.length === 0
      ) {
        return this.internalLinkType.base;
      }

      return `${this.internalLinkType.base}:${this.suffixContent.join(':')}`;
    },
    setShowTextToolTip(shown) {
      this.showTextToolTip = shown;
    },
    toggleTextToolTip() {
      this.showTextToolTip = !this.showTextToolTip;
    },
    getInternalLinkToolTipContent(base) {
      if (base === 'inspiration') {
        return `<ul>
                  <li>Identifier can be found from the inspiration URL in app</li>
                  <li>Example:
                    <a href="https://app.mystrength.com/v/inspirations/detail/1133c640-e3e0-40fe-83ca-70228fdd4735"
                      target="_blank">
                      https://app.mystrength.com/v/inspirations/detail/<strong>1133c640-e3e0-40fe-83ca-70228fdd4735</strong>
                    </a></li>
                  <li>The identifier for this inspiration is the last part of the URL : <strong>1133c640-e3e0-40fe-83ca-70228fdd4735</strong></li>
                </ul>`;
      } else if (base === 'activity') {
        return `<ul>
                  <li>Identifier can be found from the activity URL in app</li>
                  <li>Example:
                    <a href="https://app.mystrength.com/v/activity/be_open_to_new_eyes/intro"
                      target="_blank">
                      https://app.mystrength.com/v/activity/<strong>be_open_to_new_eyes</strong>/intro
                    </a></li>
                  <li>
                    The identifier for this activity is the part right after activity/ and before /intro in the URL :
                    <strong>be_open_to_new_eyes</strong>
                  </li>
                </ul>`;
      } else if (base === 'program') {
        return `<ul>
                  <li>Identifier can be found from the program URL in app</li>
                  <li>Example:
                    <a href="https://app.mystrength.com/v/program/29978"
                      target="_blank">
                      https://app.mystrength.com/v/program/<strong>29978</strong>
                    </a></li>
                  <li>The identifier for this program is the last part of the URL : <strong>29978</strong></li>
                </ul>`;
      } else if (base === 'search') {
        return `<ul>
                  <li>Query is a term used to direct a user to a search results view</li>
                  <li>Example: <strong>sleep</strong></li>
                  <li>Would lead to a search results view for the term: <strong>sleep</strong></li>
                </ul>`;
      }
      console.warn('Invalid tooltip base : ', base);
      return 'ERROR: report this to development';
    },
    stringStartsWithVowel(string) {
      const firstCharacter = string[0];
      return (
        firstCharacter === 'a' ||
        firstCharacter === 'e' ||
        firstCharacter === 'i' ||
        firstCharacter === 'o' ||
        firstCharacter === 'u'
      );
    },
    ...mapActions(['getCoachingMessageInternalLinkOptions'])
  },
  watch: {
    internalLinkType(linkType) {
      this.attachmentValid = null;

      if (!linkType) {
        this.internalLinkValidationMessage = '';
      }
      // Setup suffix initial model values
      if (linkType && linkType.suffix) {
        this.suffixContent = linkType.suffix.reduce((acc, suffix) => {
          acc.push('');
          return acc;
        }, []);
      }
      // Validate user input values against coachingMessageInternalLinkOptions
      this.validateAttachment();
    },
    suffixContent: {
      deep: true,
      handler() {
        // Validate user input values against coachingMessageInternalLinkOptions
        this.validateAttachment();
      }
    },
    attachmentValid(value) {
      if (value) {
        this.$emit('internal-message-valid', this.getInternalMessageString());
      } else {
        this.$emit('internal-message-invalid');
      }
    }
  },
  mounted() {
    if (
      !this.coachingMessageInternalLinkOptions ||
      !this.coachingMessageInternalLinkOptions.length > 0
    ) {
      this.getCoachingMessageInternalLinkOptions().then(() => this.init());
    } else {
      this.init();
    }
  }
};
</script>
<style lang="scss">
// Needed because of v-html usage
.internal-link-input-wrapper .label-inline-wrapper .tooltip-content {
  ul {
    margin: 0;
    li {
      &:last-child {
        margin-bottom: 0;
      }
      margin-bottom: $small-spacing;
    }
  }
}
</style>
<style lang="scss" scoped>
.internal-link-input-wrapper {
  flex-basis: 100%;
  padding: 0 5px; // 5px for :focus outline

  .input-group {
    margin-bottom: $small-spacing;
  }
  .label-inline-wrapper {
    position: relative;
    padding-bottom: 4px;

    .label-inline {
      display: inline;
    }
  }

  // Internal link tooltip
  .has-tooltip {
    position: static;
    margin-left: calc($small-spacing/3);
  }

  .internal-link-tooltip-content {
      top: auto;
      right: auto;
      bottom: 33px;
      left: 0px;
      width: 100%;
      word-break: break-word;
  }

  // Transition
  .fade-enter-active, .fade-leave-active {
  transition: opacity .34s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>
